import React from 'react';
import { Activity, ArrowRight } from 'lucide-react';
import { StravaConnectButton, PoweredByStrava } from './StravaAssets';
import { connectProvider } from '../utils/capacitorUtils';

const API_URL = import.meta.env.VITE_API_URL || (window.location.hostname === 'localhost' ? 'http://localhost:3000/api' : '/api');

const EmptyState = ({ isStravaAuthenticated, userId, onSync }) => {
  const [isSyncing, setIsSyncing] = React.useState(false);

  const handleAction = async () => {
    if (!isStravaAuthenticated) {
      connectProvider('strava', userId, API_URL);
    } else {
      if (onSync) {
        setIsSyncing(true);
        await onSync();
        setIsSyncing(false);
      } else {
        window.open('https://www.strava.com', '_blank');
      }
    }
  };
  return (
    <div className="glass-panel" style={{ 
      padding: '4rem 2rem', 
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '400px',
      background: 'linear-gradient(145deg, rgba(30, 32, 36, 0.6) 0%, rgba(20, 22, 26, 0.8) 100%)',
      border: '1px solid rgba(255, 255, 255, 0.05)',
      boxShadow: '0 20px 40px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.1)',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Decorative background glow */}
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '300px',
        height: '300px',
        background: 'radial-gradient(circle, rgba(252, 76, 2, 0.1) 0%, rgba(252, 76, 2, 0) 70%)',
        zIndex: 0
      }} />

      <div className="float-animation" style={{
        background: 'linear-gradient(135deg, rgba(252, 76, 2, 0.2), rgba(252, 76, 2, 0.05))',
        padding: '1.5rem', 
        borderRadius: '50%', 
        marginBottom: '2rem',
        display: 'inline-flex', 
        boxShadow: '0 0 30px rgba(252, 76, 2, 0.2)',
        position: 'relative',
        zIndex: 1
      }}>
        <Activity size={48} style={{ color: '#fc4c02' }} className="pulse-glow" />
      </div>
      
      <h2 className="text-2xl" style={{ 
        color: 'white', 
        fontWeight: '700',
        marginBottom: '1rem',
        position: 'relative',
        zIndex: 1
      }}>
        Aún no hay sudor registrado
      </h2>
      
      <p className="text-muted" style={{ 
        maxWidth: '500px', 
        lineHeight: '1.6', 
        fontSize: '1.1rem',
        marginBottom: '2.5rem',
        position: 'relative',
        zIndex: 1
      }}>
        Sal ahí fuera, rompe a sudar y sincroniza tu primera actividad en Strava para que la IA empiece a hacer su magia con tus datos.
      </p>

      {!isStravaAuthenticated ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem', position: 'relative', zIndex: 1 }}>
          <StravaConnectButton 
            onClick={handleAction} 
            disabled={isSyncing} 
            style={{ padding: '0.85rem 1.8rem', fontSize: '1.05rem', borderRadius: '8px' }}
          />
          <PoweredByStrava style={{ marginTop: '0.5rem' }} />
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem', position: 'relative', zIndex: 1 }}>
          <button 
            onClick={handleAction}
            disabled={isSyncing}
            style={{
              background: 'var(--strava-orange)', 
              color: 'white', 
              border: 'none',
              padding: '0.9rem 2.2rem', 
              borderRadius: '8px', 
              fontSize: '1rem', 
              fontWeight: 600,
              cursor: isSyncing ? 'not-allowed' : 'pointer', 
              display: 'flex', 
              alignItems: 'center', 
              gap: '0.75rem',
              boxShadow: '0 8px 25px rgba(252, 76, 2, 0.4)', 
              transition: 'all 0.3s ease',
              opacity: isSyncing ? 0.7 : 1
            }}
            onMouseOver={e => {
              if (!isSyncing) {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 12px 30px rgba(252, 76, 2, 0.6)';
              }
            }}
            onMouseOut={e => {
              if (!isSyncing) {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(252, 76, 2, 0.4)';
              }
            }}
          >
            {isSyncing ? 'Sincronizando...' : 'Sincronizar ahora'}
            <ArrowRight size={18} />
          </button>
          <PoweredByStrava style={{ marginTop: '0.5rem' }} />
        </div>
      )}
    </div>
  );
};

export default EmptyState;
